import {STATE_PROP} from 'app/reusable/entities/add-modal/add-entities-modal-constants'

export const getAddCompaniesModal = state => state[STATE_PROP]
